import { render, staticRenderFns } from "./Statcard.vue?vue&type=template&id=5c363eb0&"
import script from "./Statcard.vue?vue&type=script&lang=ts&"
export * from "./Statcard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports